import { render, staticRenderFns } from "./ImportForm.vue?vue&type=template&id=2d417970"
import script from "../../controllers/image_import/import-form.js?vue&type=script&lang=js&external"
export * from "../../controllers/image_import/import-form.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports